import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    actionType: String,
    providerTitle: String,
    providerIconOnly: Boolean,
    dataUrl: String,
    dataMethod: String,
  };

  showConfirmationDialog(event) {
    event.preventDefault();

    const title = `${this.actionTypeValue} ${this.providerTitleValue} account?`;
    const blogSharingDisabledMessage = 'You will no longer be able to share blog posts from your LawLytics account.';
    let confirmationText;

    if (this.actionTypeValue === "Delete") {
      confirmationText = `Delete ${this.providerTitleValue} account? This will remove the link from your sites(s).`;
      if (!this.providerIconOnlyValue) {
        confirmationText += ` ${blogSharingDisabledMessage}`;
      }
    } else {
      confirmationText = `${blogSharingDisabledMessage} However, you can still choose to display the link on your site.`;
    }

    const dialog = $(
      `<div id='dialog-confirm' role='alert'><p>${confirmationText}</p></div>`
    );

    dialog.dialog({
      dialogClass: "social_account_custom_confirmation_modal",
      resizable: false,
      draggable: false,
      modal: true,
      title: title,
      buttons: {
        Cancel: {
          text: "Cancel",
          click: function () {
            $(this).dialog("close");
          },
        },
        Action: {
          text: `${this.actionTypeValue}`,
          click: function () {
            $(this).dialog("close");
          },
          "data-url": this.dataUrlValue,
          "data-method": this.dataMethodValue,
          "data-remote": "true",
          class: `resource-${this.actionTypeValue.toLowerCase()}`,
        },
      },
    });
  }
}
